/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import iconSet from 'quasar/icon-set/material-icons.js'



import {Notify} from 'quasar'



export default { config: {"brand":{"primary":"#00befe","secondary":"#37CDBE","accent":"#FF5B5B","dark":"#1D1D1D","positive":"#4CAF50","negative":"#F44336","info":"#2196F3","warning":"#FB8C00"}},iconSet,plugins: {Notify} }

